// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "async-vendors" + "." + "a2d923b72ad029373a67" + ".js";
};